import { RelatedArticleDataI } from "@/services/Articles/updateArticle";
import { Link } from "react-router-dom";
import { Tooltip } from "antd";
import { t } from "i18next";

export const RelatedArticles = ({ relatedArticlesData, className }: { relatedArticlesData: RelatedArticleDataI[], className: string }) => {
    return (
        <div
            className={className}
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                marginTop: '20px',
                color: 'var(--color-text)',
            }}
        >
            <h3>{t("relatedArticlesTitle")}</h3>
            <div
                className="related-grid"
                style={{
                    display: "grid",
                    gap: "10px",
                }}
            >
                {relatedArticlesData.map((article) => (
                    <Link key={article.id}
                        to={`/blog/${article.slug}`}
                        style={{ textDecoration: "none", color: "inherit" }}>
                        <div
                            style={{
                                border: "1px solid #ddd",
                                borderRadius: "8px",
                                padding: "10px",
                                textAlign: "start",
                                boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                                cursor: "pointer",
                                transition: "transform 0.2s",
                                height: '100%',
                            }}
                        >
                            <div
                                style={{
                                    position: 'relative',       // mutlak pozisyon için parent relative olmalı
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'end',
                                }}
                            >
                                {article.isPinned && (
                                    <Tooltip title={t("pinnedText")}>
                                        <span
                                            style={{
                                                position: 'absolute',
                                                top: '-10px',
                                                fontSize: '15px',
                                                zIndex: 10,
                                            }}
                                        >
                                            📌
                                        </span>
                                    </Tooltip>

                                )}
                                <img
                                    src={article.imgUrl}
                                    alt={article.title}
                                    style={{
                                        width: "100%",
                                        aspectRatio: '2 / 1',
                                        objectFit: "cover",
                                        borderRadius: "4px",
                                        marginBottom: "8px",
                                    }}
                                />
                            </div>

                            <p style={{ fontSize: '12px', color: '#3f51b5', }} >{article.category}</p>
                            <h4 style={{ fontSize: "12px", }}>{article.title}</h4>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
};
